import script from "./Store.vue?vue&type=script&setup=true&lang=js"
export * from "./Store.vue?vue&type=script&setup=true&lang=js"

import "./Store.vue?vue&type=style&index=0&id=7d720608&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d720608"]])

export default __exports__